import { api } from './client'

export type WarehousePositionLotType = 'product' | 'packaging'

export interface WarehousePosition {
    id: string
    code: string
    name?: string | null
    applicable_lot_types: WarehousePositionLotType[]
    is_active: boolean
    created_at: string
    updated_at: string
}

export interface ListWarehousePositionsParams {
    lot_type?: WarehousePositionLotType
    is_active?: boolean
    search?: string
    page?: number
    per_page?: number
}

export interface CreateWarehousePositionRequest {
    code: string
    name?: string
    applicable_lot_types: WarehousePositionLotType[]
}

export interface UpdateWarehousePositionRequest {
    code?: string
    name?: string | null
    applicable_lot_types?: WarehousePositionLotType[]
    is_active?: boolean
}

const BASE = '/warehouse-positions'

export const warehousePositionApi = {
    list: (params?: ListWarehousePositionsParams) =>
        api.get<WarehousePosition[]>(BASE, { params }),
    getById: (id: string) => api.get<WarehousePosition>(`${BASE}/${id}`),
    create: (data: CreateWarehousePositionRequest) =>
        api.post<WarehousePosition>(BASE, data),
    update: (id: string, data: UpdateWarehousePositionRequest) =>
        api.patch<WarehousePosition>(`${BASE}/${id}`, data),
    remove: (id: string) => api.delete(`${BASE}/${id}`),
}
